module.exports = __webpack_public_path__ + "24b0546735dda71323e9bdfe20729b84.pdf";